import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrequenciaSolicitacaoCarga } from 'app/interfaces/enum/frequencia-solicitacao-carga';
import { OportunidadeMotivoPricing } from 'app/interfaces/enum/oportunidade-motivo-pricing';
import { StatusOportunidadeOfertaTr } from 'app/interfaces/enum/status-oportunidade-oferta-tr';
import { TipoEmailOportunidadeOferta } from 'app/interfaces/enum/tipo-email-oportunidade-oferta';
import { FrequenciaDatasProjecoesExcecoes } from 'app/interfaces/frequencia-datas-projecoes-excecoes';
import { HomeOportunidadeOferta } from 'app/interfaces/home-oportunidade-oferta';
import { HomeOportunidadeOfertasVendedor } from 'app/interfaces/home-oportunidade-ofertas-vendedor copy';
import { OportunidadeOfertaTr } from 'app/interfaces/oportunidade-oferta-tr';
import { OportunidadeOfertaTrControleBooking } from 'app/interfaces/oportunidade-oferta-tr-controle-booking';
import { FrequenciaInfo } from 'app/interfaces/oportunidade-oferta-tr-frequencia-info';
import { OportunidadeOfertaTrResumoCusto } from 'app/interfaces/oportunidade-oferta-tr-resumo-custo';
import { OportunidadeOfertaTrVolume } from 'app/interfaces/oportunidade-oferta-tr-volume';
import { OportunidadeOfertaTrValidacaoForm } from 'app/interfaces/oportunidade-oferta-tr-validacao-form';
import { LimiteCreditoTrResultado } from 'app/interfaces/limite-credito-tr-resultado';
import { OportunidadeTrAnalise } from 'app/interfaces/oportunidade-tr-analise';
import {
  NfeConsultaPdf,
  NfeDados,
  NfeRecebida,
  OportunidadeOfertaNfeProcessoResponse,
  OportunidadeOfertaNfeResponse,
} from 'app/interfaces/nfe-recebida';
import { OportunidadeOfertaNfeRequest } from 'app/interfaces/nfe-recebida';
import { Pageable } from 'app/interfaces/Pageable/pageable';
import { ValidacaoSolicitacaoCarga } from 'app/interfaces/validacao-solicitacao-carga';
import { ValidacaoTr } from 'app/interfaces/validacao-tr';
import { TimezoneService } from 'app/utils/timezone.service';
import { environment } from 'environments/environment';
import { OportunidadeOfertaConfiguracaoCliente } from 'app/interfaces/oportunidade-oferta-configuracao-cliente';

@Injectable({
  providedIn: 'root',
})
export class OportunidadeOfertaTrHttpService {
  constructor(
    private _http: HttpClient,
    private _timezoneService: TimezoneService
  ) {}

  getAll({
    oportunidade = '',
    origemCarga = '',
    destinoCarga = '',
    cliente = '',
    vendedor = '',
    familia = '',
    referenciaCliente = '',
    dataOportunidadeInicial = '',
    dataOportunidadeFinal = '',
    page = 0,
    sort = '',
    oportunidadeTrId = null,
    size = 200,
    status = [],
  }: {
    oportunidade?: string;
    origemCarga?: string;
    destinoCarga?: string;
    destinoFinal?: string;
    cliente?: string;
    vendedor?: string;
    familia?: string;
    referenciaCliente?: string;
    dataOportunidadeInicial: string;
    dataOportunidadeFinal: string;
    page?: number;
    sort?: string;
    oportunidadeTrId?: number;
    size?: number;
    status?: StatusOportunidadeOfertaTr[];
  }) {
    let params = {
      oportunidade: oportunidade,
      origemCarga: origemCarga,
      destinoCarga: destinoCarga,
      cliente: cliente,
      vendedor: vendedor,
      familia: familia,
      referenciaCliente: referenciaCliente,
      dataOportunidadeInicial: dataOportunidadeInicial,
      dataOportunidadeFinal: dataOportunidadeFinal,
      oportunidadeTrId: oportunidadeTrId ? oportunidadeTrId : '',
      page: page,
      sort: sort,
      size: size ? size : '',
      status: status ? status : [],
    };
    return this._http.get<Pageable>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr`, { params: params });
  }

  getAllGrid({
    oportunidade = '',
    origemCarga = '',
    destinoCarga = '',
    cliente = '',
    tipoFreteTr = '',
    referenciaCliente = '',
    dataOportunidadeInicial = '',
    dataOportunidadeFinal = '',
    dataValidadeInicial = '',
    dataValidadeFinal = '',
    page = 0,
    sort = '',
    oportunidadeTrId = null,
    quantidadeProcessos = null,
    size = 200,
    status = [],
  }: {
    oportunidade?: string;
    origemCarga?: string;
    destinoCarga?: string;
    cliente?: string;
    tipoFreteTr?: string;
    referenciaCliente?: string;
    dataOportunidadeInicial: string;
    dataOportunidadeFinal: string;
    dataValidadeInicial?: string;
    dataValidadeFinal?: string;
    page?: number;
    sort?: string;
    oportunidadeTrId?: number;
    quantidadeProcessos?: number;
    size?: number;
    status?: StatusOportunidadeOfertaTr[];
  }) {
    let params = {
      oportunidade: oportunidade,
      origemCarga: origemCarga,
      destinoCarga: destinoCarga,
      cliente: cliente,
      tipoFreteTr: tipoFreteTr ?? '',
      referenciaCliente: referenciaCliente,
      dataOportunidadeInicial: dataOportunidadeInicial,
      dataOportunidadeFinal: dataOportunidadeFinal,
      dataValidadeInicial: dataValidadeInicial,
      dataValidadeFinal: dataValidadeFinal,
      oportunidadeTrId: oportunidadeTrId ? oportunidadeTrId : '',
      quantidadeProcessos: quantidadeProcessos ? quantidadeProcessos : '',
      page: page,
      sort: sort,
      size: size ? size : '',
      status: status ? status : [],
    };
    return this._http.get<Pageable>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/grid`, { params: params });
  }

  getAllListarEmOportunidade({
    oportunidade = '',
    origemCarga = '',
    destinoCarga = '',
    cliente = '',
    vendedor = '',
    familia = '',
    page = 0,
    sort = '',
    oportunidadeTrId = null,
  }: {
    oportunidade?: string;
    origemCarga?: string;
    destinoCarga?: string;
    cliente?: string;
    vendedor?: string;
    familia?: string;
    page?: number;
    sort?: string;
    oportunidadeTrId?: number;
  }) {
    let params = {
      oportunidade: oportunidade,
      origemCarga: origemCarga,
      destinoCarga: destinoCarga,
      cliente: cliente,
      vendedor: vendedor,
      familia: familia,
      oportunidadeTrId: oportunidadeTrId ? oportunidadeTrId : '',
      page: page,
      sort: sort,
      size: 9999,
    };
    return this._http.get<Pageable>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/listar-em-oportunidade`, { params: params });
  }

  getAllByOportunidadeIdDTOMinimo({ oportunidadeTrId = null }: { oportunidadeTrId?: number }) {
    let params = {
      oportunidadeTrId: oportunidadeTrId ? oportunidadeTrId : '',
    };
    return this._http.get<OportunidadeOfertaTr[]>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/oportunidade-minimo`, {
      params: params,
    });
  }

  getResumoCustosByOportunidadeOfertaId(oportunidadeOfertaTrId: number) {
    return this._http.get<OportunidadeOfertaTrResumoCusto>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/resumo-custos/${oportunidadeOfertaTrId}`
    );
  }

  updateResumoCustosByOfertaId(oportunidadeOfertaTrId: number, validaCamposCustos = false as Boolean) {
    const params = {
      'valida-campos-custos': validaCamposCustos,
    };
    return this._http.put<OportunidadeOfertaTrResumoCusto>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/resumo-custos/${oportunidadeOfertaTrId}?valida-campos-custos=${validaCamposCustos}`,
      null
    );
  }

  getById(id: number) {
    return this._http.get<OportunidadeOfertaTr>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${id}`);
  }

  getByIdSelecao(id: number, oportunidadeTrId: number) {
    const params = { oportunidadeTrId };
    return this._http.get<OportunidadeOfertaTr>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/selecao/${id}`, { params });
  }

  validarCamposObrigatoriosPricing(oportunidadeTrId: number, oportunidadeOfertaTrIds: number[], motivo: OportunidadeMotivoPricing) {
    const params = {
      oportunidadeOfertaTrIds: oportunidadeOfertaTrIds.join(','),
      oportunidadeTrId: oportunidadeTrId,
      motivo: motivo,
    };
    return this._http.get<OportunidadeOfertaTr>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/validar-campos-obrigatorios-pricing`,
      {
        params,
      }
    );
  }

  salvar(oportunidadeOferta: OportunidadeOfertaTr) {
    return this._http.post<OportunidadeOfertaTr>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr`, oportunidadeOferta);
  }

  getConfiguracaoOfertaCliente(parceiroNegocioId: number) {
    return this._http.get<OportunidadeOfertaConfiguracaoCliente>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/configuracao-oferta-cliente`,
      { params: { parceiroNegocioId } }
    );
  }

  replicar(idReplicado: number, replicarCustos: boolean) {
    const params = {
      replicarCustos: replicarCustos,
    };
    return this._http.get<OportunidadeOfertaTr>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/replicar/${idReplicado}`, {
      params,
    });
  }

  salvarRapido(oportunidadeOferta: OportunidadeOfertaTr) {
    return this._http.post<OportunidadeOfertaTr>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/criacao-rapida`,
      oportunidadeOferta
    );
  }

  buscarNfeRecebidasSefaz() {
    return this._http.get<NfeRecebida[]>(`${environment.apiUrl}/api/process-tr/v1/sefaz-api/nfe-recebidas`);
  }

  consultarNfePorPdf(arquivo: File) {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    return this._http.post<NfeConsultaPdf>(`${environment.apiUrl}/api/process-tr/v1/sefaz-api/nfe-pdf`, formData);
  }

  analisarNfeXml(arquivo: File) {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    return this._http.post<NfeDados>(`${environment.apiUrl}/api/process-tr/v1/sefaz-api/nfe-xml`, formData);
  }

  criarOfertaPorNfe(request: OportunidadeOfertaNfeRequest) {
    return this._http.post<OportunidadeOfertaNfeResponse>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/nfe`, request);
  }

  criarOfertaPorNfes(request: OportunidadeOfertaNfeRequest) {
    return this._http.post<OportunidadeOfertaNfeResponse>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/nfe-multipla`, request);
  }

  anexarArquivoNfe(ofertaId: number, arquivo: File) {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    return this._http.post<void>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${ofertaId}/nfe-anexo`, formData);
  }

  anexarArquivosNfe(ofertaId: number, processoTrId: number | null, arquivos: File[]) {
    const formData = new FormData();
    arquivos.forEach(arquivo => formData.append('arquivos', arquivo));
    const params = processoTrId ? `?processoTrId=${processoTrId}` : '';
    return this._http.post<string[]>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${ofertaId}/nfe-anexos${params}`, formData);
  }

  aprovarGerarProcessoNfe(ofertaId: number) {
    return this._http.post<OportunidadeOfertaNfeProcessoResponse>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${ofertaId}/nfe-aprovar-gerar-processo`,
      null
    );
  }

  /*   atualizarStatusPorEnvioDeEmail(id: number, oportunidadeTrId: number, tipoEmail: TipoEmailOportunidadeOferta) {
    const params = {
      tipoEmail: tipoEmail,
      oportunidadeTrId: oportunidadeTrId,
    };
    return this._http.get<boolean>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/atualiza-status-email-enviado/${id}`, { params });
  }
 */
  update(oportunidadeOferta: OportunidadeOfertaTr) {
    return this._http.put<OportunidadeOfertaTr>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${oportunidadeOferta.oportunidadeOfertaTrId}`,
      oportunidadeOferta
    );
  }

  aprovarOferta(oportunidadeTrId: number, oportunidadeOferta: OportunidadeOfertaTr) {
    const params = {
      oportunidadeTrId: oportunidadeTrId,
      oportunidadeOfertaTrId: oportunidadeOferta.oportunidadeOfertaTrId,
    };
    return this._http.get<OportunidadeOfertaTr[]>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/aprovar-oferta`, { params });
  }

  avaliarLimiteCredito(clienteId: number, momento: string, valorTotalVendaOferta?: number) {
    const params: any = { momento };
    if (valorTotalVendaOferta !== undefined && valorTotalVendaOferta !== null) {
      params.valorTotalVendaOferta = valorTotalVendaOferta;
    }
    return this._http.get<LimiteCreditoTrResultado>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${clienteId}/avaliar-limite-credito`,
      { params }
    );
  }

  reprovarOferta(oportunidadeOfertaTrId: number, motivo: string, justificativa: string) {
    const body = {
      oportunidadeOfertaTrId: oportunidadeOfertaTrId,
      motivo: motivo,
      justificativa: justificativa,
    };
    return this._http.post<OportunidadeOfertaTr>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/reprovar-oferta`, body);
  }

  reciclarOferta(oportunidadeOfertaTrId: number, justificativa: string) {
    const params = { justificativa: justificativa };
    return this._http.put<OportunidadeOfertaTr>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/reciclar-oferta/${oportunidadeOfertaTrId}`,
      null,
      { params }
    );
  }

  delete(id: number) {
    return this._http.delete<boolean>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${id}`);
  }

  getOportunidadeOfertas() {
    return this._http.get<OportunidadeOfertaTr[]>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/all`);
  }

  findMostRecentOfertaRotaByStatus(origemId: number, destinoId: number, status: StatusOportunidadeOfertaTr) {
    const params = {
      origemId: origemId,
      destinoId: destinoId,
      status: status.toUpperCase(),
    };
    return this._http.get<OportunidadeTrAnalise>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/mais-recente-rota`, { params });
  }

  geraProcessoExtra(oportunidadeOfertaTrId: number, quantidade: number) {
    const params = {
      quantidade: quantidade,
    };
    return this._http.get<boolean>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/gera-processo-extra/${oportunidadeOfertaTrId}`, {
      params,
    });
  }

  geraProcessoPelaOferta(ofertaId: number) {
    return this._http.get<number>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/gera-processo-pela-oferta`, {
      params: { ofertaId },
    });
  }

  getOfertaMaisAntigaByOportunidadeId(oportunidadeTrId: number) {
    const params = {
      oportunidadeTrId: oportunidadeTrId,
    };
    return this._http.get<OportunidadeOfertaTr>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/mais-antiga`, { params });
  }

  /* solicitarBooking(ofertaId: number) {
    const params = {
      ofertaId: ofertaId,
    };
    return this._http.get<boolean>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/solicitar-booking`, { params });
  } */

  getAllAudit(faturaId: number, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    let params = {
      size: 10,
      page: page,
      dataInicial: dataInicial ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
    };

    return this._http.get<Pageable>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidades-ofertas-tr-auditorias

/${faturaId}`,
      { params: params }
    );
  }

  findOfertasByCodigo(codigoOferta: string) {
    return this._http.get<OportunidadeOfertaTr[]>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/find-ofertas-by-codigo?codigoOferta=${codigoOferta}`
    );
  }

  salvaNCMsOferta(ncms: string, ofertaId: number) {
    return this._http.put<boolean>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/salvar-ncms-oferta/${ofertaId}?ncms=${ncms}`,
      null
    );
  }

  aprovarOfertaLiberarEnvio(oportunidadeTrId: number, oportunidadeOferta: OportunidadeOfertaTr, liberarEnvio: boolean) {
    const params = {
      oportunidadeTrId: oportunidadeTrId,
      oportunidadeOfertaTrId: oportunidadeOferta.oportunidadeOfertaTrId,
      liberarEnvio: liberarEnvio,
    };
    return this._http.get<OportunidadeOfertaTr[]>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/aprovar-oferta-liberar-envio`, {
      params,
    });
  }

  atualizarLiberarEnvio(oportunidadeOfertaTrId: number, liberarEnvio: boolean) {
    return this._http.put<boolean>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${oportunidadeOfertaTrId}/liberar-envio`, null, {
      params: { liberarEnvio },
    });
  }

  atualizarCalculoFreteVenda(oportunidadeOfertaTrId: number, formaCalculoFreteVenda: string, percentualMargemFrete: number) {
    const params: { [param: string]: string | number } = { formaCalculoFreteVenda };
    if (percentualMargemFrete !== null && percentualMargemFrete !== undefined) {
      params.percentualMargemFrete = percentualMargemFrete;
    }

    return this._http.put<boolean>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${oportunidadeOfertaTrId}/calculo-frete-venda`,
      null,
      { params }
    );
  }

  isTarifarioDentroFaixaPeso(oportunidadeOferta: OportunidadeOfertaTr) {
    return this._http.post<boolean>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/verificar-faixa-peso-tarifario`,
      oportunidadeOferta
    );
  }

  getAuditComparacao(oportunidadeOfertaTrId: number, rev: number) {
    return this._http.get<any[]>(`${environment.apiUrl}/api/process-tr/v1/oportunidades-ofertas-tr-auditorias/comparacao-audit/
    ${oportunidadeOfertaTrId}?rev=${rev}`);
  }

  findOfertasByCodigoControleBooking(codigoOferta: string) {
    return this._http.get<OportunidadeOfertaTrControleBooking[]>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/find-ofertas-by-codigo-controle-booking?codigoOferta=${codigoOferta}`
    );
  }

  getResultadoCalculoCubagem(volume: OportunidadeOfertaTrVolume) {
    return this._http.post<OportunidadeOfertaTrVolume>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/calcular-cubagem`, volume);
  }

  getInformacaoGraficoOportunidadeOfertasVendedor(vendedorId: number, dataInicial?: string, dataFinal?: string) {
    const params: any = { vendedorId };

    if (dataInicial) params.dataInicial = dataInicial;
    if (dataFinal) params.dataFinal = dataFinal;

    return this._http.get<HomeOportunidadeOfertasVendedor[]>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/resumo-ofertas-by-vendedor`,
      {
        params,
      }
    );
  }

  getOfertasAprovadasValidasByCodigo(codigoOferta: string) {
    let params: {
      page: number;
      size: number;
      codigoOferta: string;
    } = {
      page: 0,
      size: 200,
      codigoOferta,
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/ofetas-aprovadas-validas-by-codigo`, { params });
  }

  getDatasProjecaoFrequencia(
    ano: number,
    oportunidadeOfertaTrId: number,
    frequencia: FrequenciaSolicitacaoCarga,
    dataValidade: string,
    frequenciaInfo: FrequenciaInfo
  ) {
    const { horarioInicio, horarioFim, ...frequenciaInfoRequest } = frequenciaInfo;

    return this._http.post<FrequenciaDatasProjecoesExcecoes>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/projetar-datas-solicitacao-carga`,
      {
        ano,
        oportunidadeOfertaTrId,
        dataValidade,
        frequencia,
        frequenciaInfo: frequenciaInfoRequest,
      }
    );
  }

  salvarExcecoesDatasSolicitacaoCarga(
    oportunidadeOfertaTrId: number,
    datasRemovidasSolicitacaoCarga: Date[],
    datasAdicionaisSolicitacaoCarga: Date[]
  ) {
    return this._http.put<boolean>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/salvar-excecoes-datas-solicitacao-carga/${oportunidadeOfertaTrId}`,
      {
        datasAdicionaisSolicitacaoCarga: datasAdicionaisSolicitacaoCarga.length > 0 ? datasAdicionaisSolicitacaoCarga : null,
        datasRemovidasSolicitacaoCarga: datasRemovidasSolicitacaoCarga.length > 0 ? datasRemovidasSolicitacaoCarga : null,
      }
    );
  }

  findAllValidacoes(oportunidadeOfertaTrId: number) {
    return this._http.get<ValidacaoTr[]>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${oportunidadeOfertaTrId}/validacoes`);
  }

  salvarValidacao(oportunidadeOfertaTrId: number, form: OportunidadeOfertaTrValidacaoForm) {
    return this._http.post<ValidacaoTr>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${oportunidadeOfertaTrId}/validacoes`, form);
  }

  atualizarValidacao(oportunidadeOfertaTrId: number, oportunidadeOfertaTrValidacaoId: number, form: OportunidadeOfertaTrValidacaoForm) {
    return this._http.put<ValidacaoTr>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${oportunidadeOfertaTrId}/validacoes/${oportunidadeOfertaTrValidacaoId}`,
      form
    );
  }

  getAllAuditValidacoes(oportunidadeOfertaTrId: number, page: number, email: string, dataInicial: Date, dataFinal: Date, tipoAuditoria: string) {
    const params = {
      size: 10,
      page: page,
      dataInicial: dataInicial ? this._timezoneService.utcToUserString(dataInicial) : '',
      dataFinal: dataFinal ? this._timezoneService.utcToUserString(dataFinal) : '',
      email: email ? email : '',
      tipoAuditoria: tipoAuditoria ? tipoAuditoria : '',
    };

    return this._http.get<Pageable>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-oferta-tr-validacao-auditorias/${oportunidadeOfertaTrId}`, {
      params: params,
    });
  }

  getAuditComparacaoValidacao(oportunidadeOfertaTrValidacaoId: number, rev: number) {
    return this._http.get<any[]>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-oferta-tr-validacao-auditorias/comparacao-audit/${oportunidadeOfertaTrValidacaoId}?rev=${rev}`
    );
  }

  avaliarSolicitacaoCarga(oportunidadeOfertaTrId: number) {
    return this._http.get<ValidacaoSolicitacaoCarga>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/${oportunidadeOfertaTrId}/validacao-solicitacao-carga`
    );
  }

  getInformacaoGraficoOportunidadeOfertasRodoviario(dataInicial?: string, dataFinal?: string) {
    const params: any = {};

    if (dataInicial) params.dataInicial = dataInicial;
    if (dataFinal) params.dataFinal = dataFinal;

    return this._http.get<HomeOportunidadeOferta[]>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/resumo-ofertas`, { params });
  }

  calcularDistanciaKm(origemId: number, destinoId: number, quantidadeEixos?: number) {
    const params: any = { origemId, destinoId };

    if (quantidadeEixos) params.quantidadeEixos = quantidadeEixos;

    return this._http.get<number>(`${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/distancia`, { params });
  }
  getEvolucaoMensalOfertas() {
    return this._http.get<Record<string, (number | null)[]>>(
      `${environment.apiUrl}/api/process-tr/v1/oportunidade-ofertas-tr/evolucao-mensal-ofertas`
    );
  }
}
